<template>
  <div class="sidebaright">
    <div class="conteudo">
      <span class="fechar" @click.self="$emit('fechar-filterAside')">x</span>
      <h2>Filtros</h2>
      <div class="filtros">
        <ul >
          <li class="filtro">
            <label> Departamento</label>
            <vue-select
              class="select"
              v-model="filtros.departamento"
              :options="dados.departamentos.flat()"
              label-by="nome"
              value-by="id"
              color="purple darken-3"
              :empty-model-value="''"
              @selected="payload => filtrarDepartamento(payload.id)"
              placeholder="Departamento"
              close-on-select></vue-select>
          </li>
          <li class="filtro">
            <label >Categoria</label>
            <vue-select
                class="select"
                v-model="filtros.categoria"
                :options="dados.categorias.flat()"
                label-by="nome"
                value-by="id"
                :empty-model-value="''"
                close-on-select
                @selected="payload => filtrarCategoria(payload.id)"
                placeholder="Categoria"></vue-select>
          </li>
          <li class="filtro">
            <label >Subcategoria</label>
            <vue-select
                v-model="filtros.subcategoria"
                :options="dados.subcategorias.flat()"
                label-by="nome"
                value-by="id"
                :empty-model-value="''"
                close-on-select
                placeholder="Subcategoria"></vue-select>
          </li>
          <li class="filtro">
            <label >Marca</label>
            <vue-select
                v-model="filtros.marca"
                :options="dados.marcas.flat()"
                label-by="nome"
                value-by="id"
                :empty-model-value="''"
                close-on-select
                :searchable="true"
                search-placeholder="Digite para pesquisar"
                placeholder="Marca"></vue-select>
          </li>
        </ul>
          <button class="clearBtn" v-on:click.prevent="clear">Limpar Filtros</button>
          <button class="filtrarBtn"
            @click.prevent="filtroAside">Filtrar
          </button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { reactive } from '@vue/reactivity'
import { onBeforeMount, onMounted } from '@vue/runtime-core'
import VueSelect from 'vue-next-select'
import 'vue-next-select/dist/index.min.css'

const url = process.env.VUE_APP_API_URL

export default {
  name: 'FilterAside',
  emits: ['filtroCuston', 'fechar-filterAside'],
  setup (_, { emit }) {
    const filtros = reactive({
      departamento: '',
      categoria: '',
      subcategoria: '',
      marca: ''
    })

    const dados = reactive({
      departamentos: [{
        id: 1,
        nome: 'teste'
      }],
      categorias: [{
        id: 1,
        nome: 'cate'
      }],
      subcategorias: [{
        id: 1,
        nome: 'sub'
      }],
      marcas: [{
        id: 1,
        nome: 'marcas'
      }]

    })

    onBeforeMount(async () => {
      atualizaDepartamento()
      atualizaCategoria()
      atualizaSubcategoria()
      atualizaMarca()
    })

    const filtroAside = () => {
      // this.$store.commit('setFiltroProduto', [{
      //   departamento: filtros.departamento !== 0 ? parseInt(filtros.departamento, 10) : 0,
      //   categoria: filtros.categoria > 0 ? parseInt(filtros.categoria, 10) : 0,
      //   subcategoria: filtros.subcategoria > 0 ? parseInt(filtros.subcategoria, 10) : 0,
      //   marca: filtros.marca > 0 ? parseInt(filtros.marca, 10) : 0
      // }])
      emit('filtroCuston', filtros)
    }

    const filtrarCategoria = (value) => {
      const departamento = filtros.departamento ?? '0'
      const categoria = value ?? '0'
      filtros.subcategoria = ''
      axios.get(`${url}subcategorias/?id_departamento=${departamento}&id_categoria=${categoria}`)
        .then((response) => {
          if (response.data.total === 0) {
            dados.subcategorias = [{ id: 0, nome: '' }]
          } else {
            dados.subcategorias = response.data
          }
        })
    }

    const filtrarDepartamento = (departamento) => {
      filtros.categoria = ''
      filtros.subcategoria = ''
      axios.get(`${url}categorias/?id_departamento=${departamento}`)
        .then((response) => {
          if (response.data.total === 0) {
            dados.categorias = [{ id: 0, nome: '' }]
            dados.subcategorias = [{ id: 0, nome: '' }]
          } else {
            dados.categorias = response.data
            console.log(dados.categorias)
            filtrarCategoria()
          }
        })
    }

    const clear = () => {
      filtros.departamento = ''
      filtros.categoria = ''
      filtros.subcategoria = ''
      filtros.marca = ''
    }

    const atualizaDepartamento = async () => {
      dados.departamentos = []
      await axios
        .get(`${url}departamentos/`)
        .then((response) => {
          dados.departamentos.push(response.data)
        })
    }

    const atualizaCategoria = async () => {
      await axios
        .get(`${url}categorias/`)
        .then((response) => {
          dados.categorias = response.data
        })
    }

    const atualizaSubcategoria = async () => {
      await axios
        .get(`${url}subcategorias/`)
        .then((response) => {
          dados.subcategorias = response.data
        })
    }

    const atualizaMarca = async () => {
      await axios
        .get(`${url}marcas/`)
        .then((response) => {
          dados.marcas = response.data
        })
    }

    return {
      filtros,
      dados,
      filtroAside,
      filtrarDepartamento,
      filtrarCategoria,
      clear,
      atualizaDepartamento,
      atualizaCategoria,
      atualizaSubcategoria,
      atualizaMarca
    }
  },
  computed: {
    filtro () {
      return this.$store.getters.getFiltrosProduto
    }
  },
  components: {
    VueSelect
  }
}
</script>

<style lang="scss">
 .sidebaright {
    position: fixed;
    z-index: 9999;
    top: 0;
    height: 100%;
    display: grid;
    transition: opacity 0.3s ease;
    color: #C2171A;
    width: 100%;
  }
  /* For width 400px and larger: */
  @media only screen and (min-width: 400px) {
    .sidebaright {
      right: 5%;
      margin-block-end: 0%;
      width: 20rem;
    }
  }
  .sidebaright:target {
    opacity: 1;
    pointer-events: auto;
  }

  span.fechar {
    cursor: pointer;
    line-height: 25px;
    font-size: 2.5rem;
    position: absolute;
    top: 5px;
    right: 5%;
  }

  .sidebaright .conteudo {
    width: 100%;
    height: 100%;
    background-color: #ffffff;
    transition: opacity 3s ease !important;
    display: flex;
    flex-flow: column wrap;
    align-content: center;

    .filtro{
      margin-top: 1rem;

      label {
        color: #C2171A;
        position: relative;
        margin-right: 5px;
        display: flex;
      }
    }

    li {
    display: grid;
      color:#000000;
    }

    .filtrarBtn {
    background-color: #FFEC00;
    color: #C2171A;
    border: none;
    border-radius: 20px;
    width: auto;
    position: relative;
    font-size: 1.5rem;
    margin-top: 2rem;
    margin-left: 0.5rem;
    margin-bottom: 0.2rem;

    }

    .filtrarBtn:hover {
      background-color: #e9d900;
      color: #d61b1e;
      border: none;
      border-radius: 20px;
      width: auto;
      position: relative;
      font-size: 1.5rem;
      margin-top: 2rem;
      margin-left: 1rem;
      margin-bottom: 0.2rem;
    }

     .clearBtn {
    background-color: #E5E5E3;
    color: #C2171A;
    border: #e9d900;
    border-radius: 20px;
    width: auto;
    position: relative;
    font-size: 1.5rem;
    margin-top: 2rem;
    margin-left: 1rem;
    margin-bottom: 0.2rem;

    }

    .clearBtn:hover {
      background-color: #cecece;
      color: #d61b1e;
      border: #e9d900;
      border-radius: 20px;
      width: auto;
      position: relative;
      font-size: 1.5rem;
      margin-top: 2rem;
      margin-left: 1rem;
      margin-bottom: 0.2rem;
    }
  }

</style> >
